/* eslint-disable @typescript-eslint/camelcase */
import { Pagination } from "@/domain/entities/Pagination";
import { Hub } from "./Hub";

export class UserEntities {
  pagination: Pagination;
  data: UserData[];
  constructor(pagination: Pagination, data: UserData[]) {
    this.pagination = pagination;
    this.data = data;
  }
}

export class QuotaTicketAccount {
  dbtaId = 0;
  dbtaBucketTicket: string | number = "";
  dbtaDexReasonCode: string[] | null = null;
  dbtaDisputeDexReasonCode: string[] | null = null;
  dbtaThreeLc: string[] = [];
  // Request-only fields for API
  dexReasonCodes?: string[] | null;
  disputeReasonCodes?: string[] | null;
  constructor(fields?: Partial<QuotaTicketAccount>) {
    Object.assign(this, fields);
  }
}

export class UserData {
  [x: string]: any;
  account_id = 0;
  username = "";
  account_name = "";
  account_email = "";
  password = "";
  account_phone_number = "";
  status = "";
  created_at = "";
  created_by = 0;
  updated_at = "";
  updated_by = 0;
  first_login = "";
  account_type = "";
  role_id = 0;
  account_role?: any;
  account_partner?: any;
  account_client?: any;
  account_vendor?: any;
  dexBucketTicketAccount = new QuotaTicketAccount();
  dbtaThreeLc: string[] = [];
  constructor(fields?: Partial<UserData>) {
    Object.assign(this, fields);
  }
}

export class UserDetailData {
  id = 0;
  username = "";
  name = "";
  email = "";
  phone_number = "";
  status = "";
  created_at = "";
  created_by = "";
  updated_at = "";
  updated_by = "";
  account_type = "";
  account_hub_code = "";
  role_name = "";
  partner?: any = "";
  client?: any = "";
  vendor?: any = "";
  assigned3lc = "";
  hub: Hub = new Hub();
  division_name = "";
  division_id = 0;
  shuttle_name = "";
  shuttle_id = 0;
  constructor(fields?: Partial<UserDetailData>) {
    Object.assign(this, fields);
  }
}

export class ReferenceEntities {
  id = "";
  names = "";
  companyName = "";
  status = "";
  partnerCityCode = "";
  constructor(fields?: Partial<ReferenceEntities>) {
    Object.assign(this, fields);
  }
}

export class RoleEntities {
  id: number;
  name: string;
  constructor(id: number, name: string) {
    this.id = id;
    this.name = name;
  }
}

export class DivisionEntities {
  divisionId = "";
  divisionName = "";
  departmentId = "";
  departmentName = "";
  constructor(fields?: Partial<DivisionEntities>) {
    Object.assign(this, fields);
  }
}

export class ShuttleEntities {
  shuttleId = "";
  shuttlePartnerId = 0;
  shuttleCode = "";
  shuttleName = "";
  shuttleHubId = 0;
  constructor(fields?: Partial<ShuttleEntities>) {
    Object.assign(this, fields);
  }
}
